document.addEventListener('DOMContentLoaded', (event) => {
  axios('../assets/json/' + appLanguage + '/video-portraits.json?=18dec').
    then(function (response) {
      if (response) {
        new videosGrid(response.data, 'video-grid--container', () => {
          new videosCarousel(response.data, 'video-grid--modal')
        }, 0, 15, null, true)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })

  /*axios('../assets/json/' + appLanguage + '/video-grid--one.json').
    then(function (response) {
      if (response) {
        new videosGrid(response.data, 'video-grid--one-container', () => {
          new videosCarousel(response.data, 'video-grid--one-modal', 15)
        }, 0, 15)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })

  axios('../assets/json/' + appLanguage + '/video-grid--two.json').
    then(function (response) {
      if (response) {
        new videosGrid(response.data, 'video-grid--two-container', () => {
          new videosCarousel(response.data, 'video-grid--two-modal', 15)
        }, 0, 15)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })

  axios('../assets/json/' + appLanguage + '/image-grid--one.json').
    then(function (response) {
      if (response) {
        new imagesGrid(response.data, 'image-grid--one', () => {
          new imagesCarousel(response.data, 'image-grid--one-modal', 15)
        },0, 15, 15)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })*/
})